const SLMATH_DOMAIN = "slmath.org"

function stripTrailingSlash(value) {
	return value ? value.replace(/\/+$/, "") : ""
}

function configuredPublicOrigin() {
	return stripTrailingSlash(process.env.VUE_APP_CANONICAL_ORIGIN || process.env.VUE_APP_MSRI_WEB_URL)
}

function browserOrigin() {
	return typeof window !== "undefined" && window.location ? stripTrailingSlash(window.location.origin) : ""
}

function browserHostname() {
	return typeof window !== "undefined" && window.location ? window.location.hostname.toLowerCase() : ""
}

function hostnameFromOrigin(origin) {
	try {
		return new URL(origin).hostname.toLowerCase()
	} catch (_error) {
		return ""
	}
}

function ensureInternalPath(path) {
	const value = path || "/"
	if (!value.startsWith("/") || value.startsWith("//")) {
		throw new Error("Application URL paths must be relative")
	}
	return value
}

export function publicOrigin() {
	return configuredPublicOrigin() || browserOrigin()
}

export function publicHostname() {
	return hostnameFromOrigin(publicOrigin()) || browserHostname()
}

export function legacyHostFor(hostname) {
	const host = (hostname || "").toLowerCase().split(":")[0]
	if (host === SLMATH_DOMAIN || host === `www.${SLMATH_DOMAIN}`) {
		return `legacy.${SLMATH_DOMAIN}`
	}

	const suffix = `.${SLMATH_DOMAIN}`
	if (host.endsWith(suffix)) {
		const environment = host.slice(0, -suffix.length)
		if (!environment.startsWith("legacy")) {
			return `legacy-${environment}.${SLMATH_DOMAIN}`
		}
	}

	return ""
}

export function legacyOrigin() {
	const configured = stripTrailingSlash(process.env.VUE_APP_LEGACY_ORIGIN)
	if (configured) {
		const origin = new URL(configured)
		if (origin.protocol !== "https:" || origin.username || origin.password || origin.origin !== configured) {
			throw new Error("Legacy origin must be an HTTPS origin")
		}
		return configured
	}
	const derivedHost = legacyHostFor(publicHostname())
	if (derivedHost) {
		return `https://${derivedHost}`
	}

	return stripTrailingSlash(process.env.VUE_APP_LEGACY_MSRI_WEB_URL)
}

export function publicUrl(path) {
	return `${publicOrigin()}${ensureInternalPath(path)}`
}

export function legacyUrl(path) {
	return `${legacyOrigin()}${ensureInternalPath(path)}`
}

export function legacyHandoffUrl(path) {
	const targetPath = encodeURIComponent(ensureInternalPath(path))
	const sourceHost = encodeURIComponent(publicHostname())
	return `${stripTrailingSlash(process.env.VUE_APP_API_URL || "/api")}/legacy_handoff?path=${targetPath}&source_host=${sourceHost}`
}

// A legacy page requires its own host-only session after modern sign-in.
export function postLoginUrl(target) {
	try {
		const destination = new URL(target || "/", publicOrigin())
		if (destination.username || destination.password) return "/"
		if (["/signin", "/gauth", "/api/sign_out"].includes(destination.pathname)) return "/"
		const path = `${destination.pathname}${destination.search}${destination.hash}`
		if (destination.origin === legacyOrigin()) return legacyHandoffUrl(path)
		if (destination.origin === publicOrigin()) return path
	} catch (_error) {
		return "/"
	}
	return "/"
}
